import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './client';

/** TanStack Query: caching, retries, pagination (PRD 5.6). Retries only transient failures. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 20_000,
      refetchOnWindowFocus: false,
      retry: (count, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
        return count < 2;
      },
    },
    mutations: { retry: false },
  },
});
